module.exports = __webpack_public_path__ + "image/dy-account.png";